<div class="help wrapper" *ngIf="userDetailsWire">
    <div class="row">
        <ul class="column small-12">

            <!-- Phone/Online help -->
            <li *ngIf="serviceLinks.contact">
                <a title="PhoneNumber" class="icon-phone" href="{{serviceLinks.contact}}">{{serviceLinks.contact}}</a>
            </li>

            <li *ngIf="serviceLinks.onlineHelp">
                <a title="OnlineHelp" class="icon-bubbles" href="{{serviceLinks.onlineHelp}}" target="_blank">{{
                        "ONLINE_HELP" | resource
                    }}</a>
            </li>

            <!-- Normal/Agent user -->
            <li *ngIf="!userDetailsWire.isAuthenticated && !userDetailsWire.isAgent">
                <a title="Login" class="icon-user" href="{{getLoginLink()}}">{{
                    "LOG_IN" | resource
                }}</a>
            </li>

            <li *ngIf="!userDetailsWire.isAuthenticated && !userDetailsWire.isAgent">
                <a title="Register" class="icon-lock" href="{{getLoginLink()}}">{{
                    "REGISTER" | resource
                }}</a>
            </li>

            <li *ngIf="userDetailsWire.isAuthenticated && !userDetailsWire.isAgent && userDetailsWire.user">
                <a title="User" class="icon-user" routerLink="/amendment/bookings"
                    routerLinkActive="active">{{userDetailsWire.user.name ? userDetailsWire.user.name : ''}}
                    {{ userDetailsWire.user.name ? '|' : '' }}
                    {{ userDetailsWire.user.email }}</a>
            </li>

            <li *ngIf="userDetailsWire.isAuthenticated && userDetailsWire.isAgent && userDetailsWire.agent">
                <a title="User" class="icon-user" routerLink="/agent/bookings"
                    routerLinkActive="active">{{userDetailsWire.agent.name}} | {{ userDetailsWire.agent.company }} |
                    {{ userDetailsWire.agent.reference }}</a>
            </li>

            <li *ngIf="userDetailsWire.isAuthenticated">
                <a title="Logout" class="icon-lock" href="{{getLogoutLink()}}">{{
                    "LOG_OUT" | resource
                }}</a>
            </li>

            <li *ngIf="userDetailsWire.isAuthenticated && userDetailsWire.isAgent">
                <a title="User" class="icon-plus" routerLink="/agent" routerLinkActive="active">{{
                        "START_NEW_RESERVATION" | resource
                    }}
                </a>
            </li>

            <!-- Okta -->
            <li *ngIf="showOkta && oktaService.loggedIn"><a class="no-click">{{oktaService.user}}</a></li>
            <li *ngIf="showOkta">
                <a *ngIf="!oktaService.loggedIn" title="Okta login" class="icon-user"
                    (click)="oktaService.oktaLogin()">Login (Okta)</a>
                <a *ngIf="oktaService.loggedIn" title="Okta logout" class="icon-lock"
                    (click)="oktaService.oktaLogout()">Log out (Okta)</a>
            </li>
        </ul>
    </div>
</div>
<div class="help wrapper" *ngIf="!userDetailsWire">
    <div class="row">
        <ul class="column small-12">
            <li><a class="dummy-loading">&nbsp;</a></li>
            <li><a class="dummy-loading">&nbsp;</a></li>
            <li><a class="dummy-loading">&nbsp;</a></li>
            <li><a class="dummy-loading">&nbsp;</a></li>
        </ul>
    </div>
</div>
